import { Widget, WIDGET_TICKER, TimeoutEvent } from "@gaming/srvg-classes-core";


export class TickerWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {

        options = options || {};
        options.selector = options.selector || '#tickerWidget';
        super( options );

        this.name = 'widgetticker';
        this.widgetName = options.widgetName || WIDGET_TICKER;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addTickerWidget();
        super.handleDomInstantiated();
    }

    /**
     * add ticker widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addTickerWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addTickerWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addTickerWidget(element);
    }

    // destroy the widget for inactivity
    handleTimeoutEvent(event: TimeoutEvent, provider){
        this.destroyWidget(this.widget, this.name);
    }

}
